<template>
  <div class="home">
    <transition name="detail_slide">
      <router-view/>
    </transition>
    <!-- <div v-for="container in activeWidgets()"
    :key="container.id"> -->
    <div
      v-if="!$vuetify.breakpoint.smAndDown || container.mobile"
      :style="`
        position: absolute;
        left: calc(${(container.position?container.position[0]:0) * (1/columns)} * (100vw - 20px)  + 10px);
        top: calc(${(container.position?container.position[1]:0) * (1/columns)} * (100vw - 20px) + 10px);
        width: calc(${container.width * (1/columns)} * (100vw - 20px));
        height: calc(${container.height * (1/columns)} * (100vw - 20px));
        padding: 9px;
        transition: all 0.3s ease-in-out;
      `"
      @click="setPosition()"
      >
      <!-- @click="setPosition()" -->
      <div  class="widget" :style="`background-color: ${container.color}`" v-if="container.widget === 'mobile'">one {{container.position}}</div>
      <div  class="widget" :style="`background-color: ${container.color}`" v-else-if="container.widget === 'two'">two {{container.position}}</div>
      <div  class="widget" :style="`background-color: ${container.color}`" v-else-if="container.widget === 'three'">three {{container.position}}</div>
      <div  class="widget" :style="`background-color: ${container.color}`" v-if="container.widget === 'one'">one {{container.position}}</div>
      <!-- <HomeWidget@click.native="setPosition()" class="widgetLogo image-logo" v-else-if="container.widget === 'logo'">
          <v-btn style="position: absolute; left: 50%; top: 0px; width: 90%; z-index: 2; transform: translateX(-50%);" v-if="$vuetify.breakpoint.smAndDown" :href="login_url"> LOGIN </v-btn>
      </HomeWidget>
      <HomeWidget class="widget" style="cursor: default" description="Our super power is the WORK.package - See you on the LCI conference Finland" noHover="true" isMessage="true" v-else-if="container.widget === 'text'"/>
      <HomeWidget @click.native="$router.push({name: 'TaktTraining'})" class="widget image-training" header="TAKT.training" description="The trainingssystem for starter, professionals and companies" v-else-if="container.widget === 'training'"/>
      <HomeWidget @click.native="$router.push({name: 'TaktAppMain'})" class="widget image-app" header="TAKT.app" description="The software for takt in construction" v-else-if="container.widget === 'app'"/>
      <HomeWidget @click.native="openNewTab('https://knowledge.takting.com/?lang=en')" class="cursor-pointer widget image-knowledge" header="TAKT. knowledge" description="enter the world of TAKT in construction with your mind" v-else-if="container.widget === 'knowledge'"/>
      <HomeWidget @click.native="$router.push({name: 'AlgorithmicFlowMain'})" class="widget image-algorithmic-flow" header="ALGORITHMIC.flow" description="Syncronizing value flows of construction sites with neuronal networks" v-else-if="container.widget === 'algorithmicFlow'"/>
      <HomeWidget @click.native="$router.push({name: 'PowerOfTaktOne'})" class="widget image-takt-power" header="Power of TAKT" description="TAKT is the foundation of a production system in construction. " v-else-if="container.widget === 'taktPower'"/>
      <HomeWidget @click.native="$router.push({name: 'TaktNewsMain'})" class="widget image-takt-news" header="Coming soon" description="Upcoming features for TAKT.app" v-else-if="container.widget === 'taktNews'"/>
      <HomeSocial class="widget" v-else-if="container.widget === 'social'"/>
      <HomeWidget @click.native="$router.push({name: 'HomeWorkbenchMain'})" class="widget image-workbench" header="WORK.bench" description="digital scaling of processes standards" v-else-if="container.widget === 'workbench'"/>
      <HomeWidget @click.native="$router.push({name: 'TaktPartnersMain'})" class="widget image-takt-partners" header="TAKT. partners" description="you need help on your construction site?" v-else-if="container.widget === 'taktPartners'"/>
      <HomeWidget @click.native="$router.push({name: 'TaktConnectionMain'})" class="widget image-takt-connection" header="TAKT. connect" description="we are looking for people and companies willing to work with TAKT. Call us!" v-else-if="container.widget === 'taktConnection'"/>
      <HomeWidget @click.native="openNewTab('https://www.process-boards.de/')" class="widget image-process-boards" header="Process Boards" description="Physical takt boards for your construction site" v-else-if="container.widget === 'processBoards'"/>
      <HomeWidget class="widget image-pikto-one" style="cursor: default" noHover="true" header="" description="" v-else-if="container.widget === 'piktoOne'"/>
      <HomeWidget class="widget image-pikto-two" style="cursor: default" noHover="true" header="" description="" v-else-if="container.widget === 'piktoTwo'"/>
      <HomeRegistrationWidget class="widget" v-else-if="container.widget === 'register'">
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 5px">
        <v-btn @click="$router.push({name: 'Apply'})" class="home-register-button"> Apply </v-btn>
        <v-btn @click="$router.push({name: 'Subscribe'})" class="home-register-button"> Newsletter </v-btn>
      </div>
      </HomeRegistrationWidget> -->
        <!-- <img src="@/assets/logo.png" style="position: absolute">Logods -->
      <!-- </div> -->
    </div>
  <!-- </div> -->
</div>
</template>
<script>
  import { UserHomeMixin } from '@/mixins/UserHome.mixin.js'
  // import HomeWidget from '@/components/Home/HomeWidget.component.vue'
  // import HomeRegistrationWidget from '@/components/Home/HomeRegistrationWidget.component.vue'
  // import HomeSocial from '@/components/Home/HomeSocial.component.vue'
  export default {
    props: [],
    components: {
      // HomeWidget,
      // HomeRegistrationWidget,
      // HomeSocial
    },
    mixins: [
      UserHomeMixin,
    ],
    data: () => ({
      login_url: process.env.VUE_APP_LOGIN_URL
    }),
    computed: {

    },
    methods: {
      openNewTab(route) {
        window.open(route)
      },
      activeWidgets: function() {
        let activeArray = [];
        this.containers.forEach((item) => {
          if (!this.$vuetify.breakpoint.smAndDown || item.mobile) {
            activeArray.push(item);
          }
        });
        return activeArray;
      }
    }
  }
</script>
<style>
.home-register-button {
  /* border: solid 1px grey; */
  /* margin-top: 5px; */
  border-radius: 10px;
  width: calc(100% - 10%);
  text-align: center;
  font-size: 30px;
  background-color: grey;
  /* opacity: 0.7; */
}
  .home {
    height: calc(100% - 78px) !important;
    width: 100%;
    padding: 10px !important;
  }
  .widgetLogo {
    height: 100%;
    width: 100%;
    border-radius: 20px;
    border: solid 1px white;
  }
  .widget {
    height: 100%;
    width: 100%;
    display: flex;
    border: solid 1px white;
    border-radius: 20px;
    /* background: linear-gradient(to bottom,rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.1),rgba(0, 0, 0, 1)); */
    /* opacity: 0.5; */
    /* justify-content: center; */
    /* align-items: center; */
  }
  .image-logo {
    border: hidden;
    padding-top: 5%;
    background: url('~@/assets/TaktingLogo.svg') 0px 10px;
  }
  .image-training {
    background-size: 100%;
    background-position: center;
    background-image: url('~@/assets/TrainingFive.png');
    /* opacity: 0.5; */
    /* background: linear-gradient(to top, black 0%, white 50%); */
  }
  .image-app {
    background-size: 100%;
    background-position: top;
    background-image: url('~@/assets/TaktPlan.png');
  }
  .image-knowledge {
    background-size: 140%;
    background-position: center;
    background-image: url('~@/assets/KnowledgeOne.jpg');
  }
  .image-algorithmic-flow {
    background-size: 100%;
    background-position: center;
    background-image: url('~@/assets/AlgorithmicFlowThree.jpg');
  }
  .image-takt-power {
    background-size: 350%;
    background-position: center;
    background-image: url('~@/assets/stopwatch.jpg');
  }
  .image-linkedIn {
    background-size: 90%;
    background-position: right;
    background-image: url('~@/assets/LinkedIn.png');
  }
  .image-takt-news {
    background-size: 90%;
    background-position: center;
    background-color: white;
    background-image: url('~@/assets/TaktIngQRCode.jpg');
  }
  .image-workbench {
    background-size: 110%;
    background-position: center;
    background-image: url('~@/assets/Workbench.jpg');
  }
  .image-takt-partners {
    background-size: 150%;
    background-position: center;
    background-image: url('~@/assets/TaktPartners.jpg');
  }
  .image-takt-connection {
    background-size: 150%;
    background-position: center;
    background-image: url('~@/assets/TaktConnections.jpg');
  }
  .image-process-boards {
    background-size: 150%;
    background-position: center;
    background-image: url('~@/assets/ProcessBoardsOne.jpg');
  }
  .image-pikto-one {
    background-size: 80%;
    background-position: center;
    /* background-image: url('~@/assets/White_Workbench.svg'); */
    background-image: url('~@/assets/White_AI.svg');
  }
  .image-pikto-two {
    background-size: 80%;
    background-position: center;
    background-image: url('~@/assets/White_Workbench.svg');
    /* background-image: url('~@/assets/White_AI.svg'); */
  }
  .detail_slide-enter, .detail_slide-leave-to {
  transform: translateY(100vh);
  }
  .detail_slide-enter-active, .detail_slide-leave-active {
    transition: transform 0.2s ease-in-out;
  }
</style>
